// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { ArticuloMonedaProps } from '../interfaces'
import { FRAGMENT_ARTICULO_MONEDA } from '../interfaces/fragment'

const query = gql`
  ${FRAGMENT_ARTICULO_MONEDA}
  query LISTADO {
    articuloMoneda {
      ...fields
    }
  }
`

/**
 * Listamos la configuración de articulo moneda
 */
export const apiArticuloMoneda = async (): Promise<ArticuloMonedaProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query)
    return data.articuloMoneda
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
